import React, { useState } from "react";
import image2 from "../../../assets/images/Card/blue.webp";
import image3 from "../../../assets/images/Card/purple.webp"
import image7 from "../../../assets/images/Card/yellow.webp";
import polygonTop from "../../../assets/images/polygon-top.png";
import polygonBtm from "../../../assets/images/polygon-bottom.png";

const TrevexBenefits = ({ prompt }) => {

  const trevexBenefitsInfo = [
    {
      title: 'Become a Trusted Business',
      imageUrl: image2,
      description: 'Gain added trust in the market when your business profile is verified by TREVEX'
    },
    {
      title: 'Manage Your Own Profile',
      imageUrl: image7,
      description: 'Present your business in its true light without biased opinions from third parties.'
    },
    {
      title: 'Stay Informed & Updated',
      imageUrl: image3,
      description: 'Access reliable, updated Business Information in an organized database'
    }
  ];

  const [hoveredCard, setHoveredCard] = useState(null);

  const handleCardClick = (title) => {
  };

  const handleCardHover = (index) => {
    setHoveredCard(index);
  };

  return (

    <div className="max-w-[1280px] relative m-0 mx-auto sm:py-30 z-[999999999]">
      {/* <div className={`w-full md:w-[100%] relative z-10 flex flex-col sm:flex-row items-center gap-4 sm:gap-2 justify-between flex-wrap py-[120px] polygon-bg px-10 mt-[-100px] min-h-[inherit] border border-red-800`}>
        <div className="w-full flex flex-wrap gap-4 justify-center sm:justify-start md:justify-evenly px-2 sm:px-0">
          {trevexBenefitsInfo.map((info, index) => (
            <div
              key={index}
              href="#"
              onClick={() => handleCardClick(info.title)}
              onMouseEnter={() => handleCardHover(index)}
              onMouseLeave={() => handleCardHover(null)}
              className={`flex flex-col items-start flexcol p-6 w-full sm:w-[382px] bg-white rounded-[8px] ${hoveredCard === index ? 'shadow' : ''}`}
              style={{
                boxShadow:
                  hoveredCard === index
                    ? '4px 0 8px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1)'
                    : ''
                      ? ''
                      : '1px 0 1px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1)',
                transform: hoveredCard === index ? 'scale(1.02)' : 'scale(1)',
                transition: 'box-shadow 0.3s ease, transform 0.3s ease',
              }}
            >
              <img
                src={info.imageUrl}
                alt={info.title}
                style={{ height: '229.374px', width: '355px', marginLeft: '-10px', maxWidth: '385px' }}
              />
              <p className="mt-1 text-[#012234] sm:text-f24 text-left text-f18 font-semibold">
                {info.title}
              </p>
              <p className="mt-1 text-[#012234] sm:text-f16 text-f14 text-normal text-left">{info.description}</p>
            </div>
          ))}
        </div>
      </div> */}
      <div className="w-full relative min-h-[inherit] mt-[-100px]">
  {/* Top decorative image */}
  <img
    src={polygonTop}
    alt="Top decoration"
    className="shape_top"
  />

  {/* Main content container */}
  <div className="shape_card-content">
    {/* Card grid */}
    <div className="cards_grid">
      {trevexBenefitsInfo.map((info, index) => (
        <div
          key={index}
          onClick={() => handleCardClick(info.title)}
          onMouseEnter={() => handleCardHover(index)}
          onMouseLeave={() => handleCardHover(null)}
          className={`flex flex-col items-start p-6 bg-white rounded-[8px] ${hoveredCard === index ? 'shadow' : ''}`}
          style={{
            boxShadow:
              hoveredCard === index
                ? '4px 0 8px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1)'
                : '1px 0 1px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1)',
            transform: hoveredCard === index ? 'scale(1.02)' : 'scale(1)',
            transition: 'box-shadow 0.3s ease, transform 0.3s ease',
          }}
        >
          <img
            src={info.imageUrl}
            alt={info.title}
            style={{ height: '229.374px', width: '355px', marginLeft: '-10px', maxWidth: '385px' }}
          />
          <p className="mt-1 text-[#012234] sm:text-f24 text-left text-f18 font-semibold">
            {info.title}
          </p>
          <p className="mt-1 text-[#012234] sm:text-f16 text-f14 text-normal text-left">
            {info.description}
          </p>
        </div>
      ))}
    </div>
  </div>

  {/* Bottom decorative image */}
  <img
    src={polygonBtm}
    alt="Bottom decoration"
    className="shape_bottom"
  />
</div>
      {!prompt && <div className="max-w-[1200px] pt-[6rem] md:pt-[10%]">
        <h1 className="mx-auto px-2 text-f24 sm:text-[3rem] md:text-[48px] font-semibold text-[#012234]">
          Improve your business credibility and keep ahead of the crowd
        </h1>
        <h6 className="max-w-[840px] px-[4%] text-f16 md:text-[1rem] px-1.5rem text-[#3C4848] font-normal m-auto">
          Our solutions allow your business to increase visibility and approach potential commercial partners with confidence
        </h6>
      </div>}
    </div>
  );
};

export default TrevexBenefits;